/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import { FC } from 'react';

import { IReportsColumnsItem } from '../types';
import { WizardColumnsSelectionListStyled } from './styled/WizardColumnsSelectionStyled';
import { WizardReportConstructorStepTitleStyled } from './styled/WizardReportConstructorStyled';
import WizardColumnsSelectionItem from './WizardColumnsSelectionItem';

interface IWizardColumnsSelectionProps {
    title: string;
    reportColumns: IReportsColumnsItem[];
}

const WizardColumnsSelection: FC<IWizardColumnsSelectionProps> = ({ title, reportColumns }) => {
    return (
        <>
            <WizardReportConstructorStepTitleStyled>{title}</WizardReportConstructorStepTitleStyled>
            <WizardColumnsSelectionListStyled>
                {reportColumns.map((el) => (
                    <WizardColumnsSelectionItem itemData={el} key={el.id} />
                ))}
            </WizardColumnsSelectionListStyled>
        </>
    );
};

export default WizardColumnsSelection;
